import { LANGUAGE_KEYS } from 'config/languageKeys';

import { CachedRecordingItem } from 'store/recordings/reducer.types';

import {
    hasSeriesRecording,
    isFailed,
    isProtectedRecording,
    isRecorded,
    isRecording,
    isScheduled,
} from 'utils/recordings';

type Params = {
    recordingItem: CachedRecordingItem;
    collectionSuspensionActive: boolean;
};

const {
    ACCESSIBILITY: {
        DETAIL_PAGE: {
            ACCESSIBILITY_ICONS_FAILED_RECORDING,
            ACCESSIBILITY_ICONS_PROTECTED_RECORDING,
            ACCESSIBILITY_ICONS_SERIES_RECORDING,
            ACCESSIBILITY_ICONS_SINGLE_RECORDING,
            ACCESSIBILITY_ICONS_SCHEDULED_SERIES_RECORDING,
            ACCESSIBILITY_ICONS_SCHEDULED_SINGLE_RECORDING,
        },
    },
} = LANGUAGE_KEYS;

export function getRecordingStatusAccessibilityLabel({
    recordingItem,
    collectionSuspensionActive,
}: Params) {
    if (isFailed(recordingItem) || collectionSuspensionActive) {
        return ACCESSIBILITY_ICONS_FAILED_RECORDING;
    }

    if (isProtectedRecording(recordingItem)) {
        return ACCESSIBILITY_ICONS_PROTECTED_RECORDING;
    }

    if (isRecorded(recordingItem)) {
        if (hasSeriesRecording(recordingItem)) {
            return ACCESSIBILITY_ICONS_SERIES_RECORDING;
        }

        return ACCESSIBILITY_ICONS_SINGLE_RECORDING;
    }

    if (isScheduled(recordingItem) || isRecording(recordingItem)) {
        if (hasSeriesRecording(recordingItem)) {
            return ACCESSIBILITY_ICONS_SCHEDULED_SERIES_RECORDING;
        }

        return ACCESSIBILITY_ICONS_SCHEDULED_SINGLE_RECORDING;
    }

    return '';
}
